import { createFileRoute } from '@tanstack/react-router';

// relative imports
import InvalidAuthRequestPage from '../../components/error-handling/InvalidRequestPage';

export const Route = createFileRoute('/_public/invalid-auth-request')({
  component: InvalidAuthRequestPage as any,
});
